import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
export function Countdown() {
  const [time, setTime] = useState({
    hours: 23,
    minutes: 59,
    seconds: 59
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTime(prev => {
        let {
          hours,
          minutes,
          seconds
        } = prev;
        if (seconds > 0) {
          seconds--;
        } else if (minutes > 0) {
          minutes--;
          seconds = 59;
        } else if (hours > 0) {
          hours--;
          minutes = 59;
          seconds = 59;
        } else {
          hours = 23;
          minutes = 59;
          seconds = 59;
        }
        return {
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const TimeBox = ({
    value,
    label
  }: {
    value: number;
    label: string;
  }) => <div className="flex flex-col items-center" data-id="element-51">
      <div className="bg-[#C6FF3C] text-black font-bold text-3xl md:text-5xl px-4 md:px-6 py-3 md:py-4 rounded-lg min-w-[70px] md:min-w-[90px] text-center" data-id="element-52">
        {String(value).padStart(2, '0')}
      </div>
      <span className="text-gray-400 text-xs md:text-sm mt-2 uppercase" data-id="element-53">
        {label}
      </span>
    </div>;
  return <section className="w-full bg-black py-12 px-4 border-y border-gray-800" data-id="element-54">
      <div className="max-w-4xl mx-auto" data-id="element-55">
        <div className="flex items-center justify-center gap-3 mb-6" data-id="element-56">
          <Clock className="w-6 h-6 text-[#C6FF3C]" data-id="element-57" />
          <h2 className="text-2xl md:text-3xl font-bold text-center uppercase" data-id="element-58">
            La Oferta Termina En:
          </h2>
        </div>

        <div className="flex justify-center gap-3 md:gap-6" data-id="element-59">
          <TimeBox value={time.hours} label="Horas" data-id="element-60" />
          <div className="text-[#C6FF3C] text-4xl md:text-6xl font-bold self-start mt-3" data-id="element-61">
            :
          </div>
          <TimeBox value={time.minutes} label="Minutos" data-id="element-62" />
          <div className="text-[#C6FF3C] text-4xl md:text-6xl font-bold self-start mt-3" data-id="element-63">
            :
          </div>
          <TimeBox value={time.seconds} label="Segundos" data-id="element-64" />
        </div>
      </div>
    </section>;
}